"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = formatDate;
exports.mapGrowCycle = mapGrowCycle;
var KNOWN_STATUSES = ["OPEN", "ACTIVE", "COMPLETE", "OVERDUE"];
function formatDate(value) {
    if (!value)
        return "";
    var parsed = new Date(value);
    if (Number.isNaN(parsed.getTime()))
        return "";
    return parsed.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}
function normalizeStatus(status) {
    var upper = status === null || status === void 0 ? void 0 : status.toUpperCase();
    return KNOWN_STATUSES.indexOf(upper) !== -1 ? upper : "OPEN";
}
function mapGrowCycle(growCycle) {
    var _a, _b, _c, _d;
    return {
        id: growCycle.id,
        name: growCycle.display_name || "Untitled Grow Cycle",
        startDate: formatDate(growCycle.start_date),
        endDate: formatDate(growCycle.end_date),
        status: normalizeStatus(growCycle.status),
        client: (_a = growCycle.client) === null || _a === void 0 ? void 0 : _a.name,
        facility: (_b = growCycle.facility) === null || _b === void 0 ? void 0 : _b.name,
        area: (_c = growCycle.area) === null || _c === void 0 ? void 0 : _c.name,
        createdBy: (_d = growCycle.created_by) === null || _d === void 0 ? void 0 : _d.name,
    };
}
